import type { Component } from "vue"

import {
  // AH work-steps
  WorkflowsAhWorkSteps01Eingangsbestaetigung,
  WorkflowsAhWorkSteps02Zustaendigkeit,
  WorkflowsAhWorkSteps03Abgeschlossenheit,
  WorkflowsAhWorkSteps04Fachsprachenpruefung,
  WorkflowsAhWorkSteps05Berufserlaubnis,
  WorkflowsAhWorkSteps06Gleichwertigkeit,
  WorkflowsAhWorkSteps07Kenntnispruefung,
  WorkflowsAhWorkSteps8Approbationsurkunde,
  WorkflowsAhWorkSteps9Verfahrensabschluss,
  WorkflowsAhWorkSteps10Archiv,
  // PUG work-steps
  WorkflowsPugWorkSteps01UnterlagenPruefen,
  WorkflowsPugWorkSteps02Vollstaendigkeit,
  WorkflowsPugWorkSteps03Ausbildungsvergleich,
  WorkflowsPugWorkSteps04Zwischenbescheid,
  WorkflowsPugWorkSteps05Zwischengebuehrenbescheid,
  WorkflowsPugWorkSteps06Anpassungsmassnahme,
  WorkflowsPugWorkSteps07Bescheid,
  WorkflowsPugWorkSteps8SonstigeBeendigung,
  WorkflowsPugWorkSteps9Gebuehrenbescheid,
  WorkflowsPugWorkSteps10Archiv,
  // common work-steps
  WorkflowsCommonWorkStepsRechtsbehelfe,
} from "#components"

export const useWorkflowComponents = (): Record<string, Component> => {
  return {
    "gsb.ah.EINGANGSBESTAETIGUNG": WorkflowsAhWorkSteps01Eingangsbestaetigung,
    "gsb.ah.ZUSTAENDIGKEIT": WorkflowsAhWorkSteps02Zustaendigkeit,
    "gsb.ah.ABGESCHLOSSENHEIT": WorkflowsAhWorkSteps03Abgeschlossenheit,
    "gsb.ah.FACHSPRACHENPRUEFUNG": WorkflowsAhWorkSteps04Fachsprachenpruefung,
    "gsb.ah.BERUFSERLAUBNIS": WorkflowsAhWorkSteps05Berufserlaubnis,
    "gsb.ah.GLEICHWERTIGKEIT": WorkflowsAhWorkSteps06Gleichwertigkeit,
    "gsb.ah.KENNTNISPRUEFUNG": WorkflowsAhWorkSteps07Kenntnispruefung,
    "gsb.ah.APPROBATIONSURKUNDE": WorkflowsAhWorkSteps8Approbationsurkunde,
    "gsb.ah.VERFAHRENSABSCHLUSS": WorkflowsAhWorkSteps9Verfahrensabschluss,
    "gsb.ah.RECHTSBEHELF": WorkflowsCommonWorkStepsRechtsbehelfe,
    "gsb.ah.ARCHIV": WorkflowsAhWorkSteps10Archiv,

    "gsb.pug.UNTERLAGEN_PRUEFEN": WorkflowsPugWorkSteps01UnterlagenPruefen,
    "gsb.pug.VOLLSTAENDIGKEIT": WorkflowsPugWorkSteps02Vollstaendigkeit,
    "gsb.pug.AUSBILDUNGSVERGLEICH": WorkflowsPugWorkSteps03Ausbildungsvergleich,
    "gsb.pug.ZWISCHENBESCHEID": WorkflowsPugWorkSteps04Zwischenbescheid,
    "gsb.pug.ZWISCHENGEBUEHRENBESCHEID":
      WorkflowsPugWorkSteps05Zwischengebuehrenbescheid,
    "gsb.pug.ANPASSUNGSMASSNAHME": WorkflowsPugWorkSteps06Anpassungsmassnahme,
    "gsb.pug.BESCHEID": WorkflowsPugWorkSteps07Bescheid,
    "gsb.pug.SONSTIGE_BEENDIGUNG": WorkflowsPugWorkSteps8SonstigeBeendigung,
    "gsb.pug.GEBUEHRENBESCHEID": WorkflowsPugWorkSteps9Gebuehrenbescheid,
    "gsb.pug.RECHTSBEHELF": WorkflowsCommonWorkStepsRechtsbehelfe,
    "gsb.pug.ARCHIV": WorkflowsPugWorkSteps10Archiv,
  }
}
